import lf from 'lovefield'

export function simuexo_cubatures_couches (schemaBuilder) {
  schemaBuilder.createTable('simuexo_cubatures_couches')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simuexo_cubatures_id', lf.Type.INTEGER)
      .addColumn('const_sols_id', lf.Type.STRING)
      .addColumn('ordre', lf.Type.INTEGER)
      .addColumn('volume', lf.Type.NUMBER)
      .addColumn('purge', lf.Type.INTEGER)
      .addPrimaryKey(['id'], true); // true == autoincrement

}





// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuexoCubaturesCouches.schema.js